import { Paper, Popper } from "@mui/material"
import { AuthoringRecommendationComparison } from "./authoring-recommendation-comparison"

const PREVIEW_POPOVER_MODIFIERS = [
    {
        name: "offset",
        options: {
            offset: [0, 12],
        },
    },
    {
        name: "preventOverflow",
        options: {
            padding: 16,
            altAxis: true,
            tether: true,
        },
    },
    {
        name: "flip",
        options: {
            fallbackPlacements: ["left", "right-start", "right"],
            padding: 16,
        },
    },
]

export function AuthoringRecommendationPreviewPopover({ recommendation, anchorEl, open, onMouseEnter, onMouseLeave }) {
    if (!recommendation || !anchorEl) return null

    return (
        <Popper
            open={open}
            anchorEl={anchorEl}
            placement="left-start"
            modifiers={PREVIEW_POPOVER_MODIFIERS}
            sx={{ zIndex: (theme) => theme.zIndex.modal }}
            data-cy="authoring-recommendation-preview-popover"
        >
            <Paper
                elevation={12}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                sx={{
                    width: 560,
                    maxWidth: "min(640px, calc(100vw - 64px))",
                    maxHeight: "calc(100vh - 64px)",
                    overflowY: "auto",
                    overflowX: "hidden",
                    borderRadius: 2,
                    p: 2,
                }}
            >
                <AuthoringRecommendationComparison item={recommendation} />
            </Paper>
        </Popper>
    )
}
